document.addEventListener("DOMContentLoaded", () => {
  const heroSection = document.querySelector(".hero-slider-section");
  const vibeSection = document.querySelector(".vibe-bundles-section");

  /* ---------------- HERO ---------------- */
  if (heroSection) {
    const heroCollection = heroSection.dataset.collection;
    const heroWrapper = heroSection.querySelector(".swiper-wrapper");

    if (heroCollection && heroWrapper) {
      fetchCollectionProducts(heroCollection, (products) => {
        renderHeroSlides(heroWrapper, products);
      });
    }
  }

  /* ---------------- VIBE BUNDLES ---------------- */
  if (vibeSection) {
    const vibeCollection = vibeSection.dataset.collection;

    const track = vibeSection.querySelector("[data-bundles-track]");
    const pagination = vibeSection.querySelector("[data-bundles-pagination]");
    const counter = vibeSection.querySelector("[data-bundles-counter]");
    const prev = vibeSection.querySelector("[data-bundles-prev]");
    const next = vibeSection.querySelector("[data-bundles-next]");

    if (vibeCollection && track && pagination && counter && prev && next) {
      fetchCollectionProducts(vibeCollection, (products) => {
        initVibeBundlesSlider({
          products,
          trackEl: track,
          paginationEl: pagination,
          counterEl: counter,
          prevBtn: prev,
          nextBtn: next,
        });
      });
    }
  }
});

function fetchCollectionProducts(collectionHandle, callback) {
  fetch(`/collections/${collectionHandle}/products.json?limit=12`)
    .then((res) => res.json())
    .then((data) => {
      const products = data.products || [];
      if (!products.length) {
        console.warn("⚠️ Empty collection:", collectionHandle);
        return;
      }
      callback(products);
    })
    .catch((err) =>
      console.error("❌ Product fetch failed:", collectionHandle, err)
    );
}

/**
 * HERO SLIDER (top of page)
 */
function renderHeroSlides(wrapper, products) {
  wrapper.innerHTML = "";

  products.forEach((product) => {
    const img =
      (product.images && product.images[1] && product.images[1].src) || "";
    const title = product.title || "";
    const handle = product.handle;

    const safeTitle = escapeHtml(title);
    const descriptionText = getFirstDescriptionSnippet(product.body_html);
    const badgeText = getProductBadgeTag(product.tags);

    wrapper.insertAdjacentHTML(
      "beforeend",
      `
    <div class="swiper-slide">
      <a href="/products/${handle}?view=single-product">
        <div class="slide-card">
          ${
            img
              ? `<img class="slide-img" src="${img}" alt="${safeTitle}" />`
              : ""
          }
          <div class="slide-overlay"></div>
          <div class="slide-content">
            ${badgeText ? `<span class="slide-tag">${badgeText}</span>` : ""}
            <h2 class="slide-title fraunces-font">${safeTitle}</h2>
            ${
              descriptionText
                ? `<p class="slide-subtitle">${descriptionText}</p>`
                : ""
            }
          </div>
        </div>
      </a>
    </div>
  `
    );
  });

  if (window.heroSwiper && typeof window.heroSwiper.update === "function") {
    window.heroSwiper.update();
  }
}

function getProductBadgeTag(tags) {
  if (!Array.isArray(tags)) return "";

  const tag = tags.find((t) => t.startsWith("tag_"));
  if (!tag) return "";

  return escapeHtml(tag.replace(/^tag_/, ""));
}

function getFirstDescriptionSnippet(html) {
  if (!html) return "";

  const temp = document.createElement("div");
  temp.innerHTML = html;

  // Get all spans
  const spans = temp.querySelectorAll("span");

  for (const span of spans) {
    const text = span.textContent.trim();
    if (text.length > 0) {
      return escapeHtml(text);
    }
  }

  // Fallback: first paragraph text
  const p = temp.querySelector("p");
  if (p) {
    return escapeHtml(p.textContent.trim());
  }

  return "";
}

/**
 * VIBE BUNDLES SLIDER (card with 2 images + persona content)
 */
function initVibeBundlesSlider({
  products,
  trackEl,
  paginationEl,
  counterEl,
  prevBtn,
  nextBtn,
}) {
  const slidesHtml = [];
  const personas = products.map(createPersonaFromProduct);

  products.forEach((product, index) => {
    const persona = personas[index];
    slidesHtml.push(createVibeSlideHtml(product, persona, index));
  });

  trackEl.innerHTML = slidesHtml.join("");

  const slideEls = Array.from(trackEl.querySelectorAll(".vibe-bundles-slide"));
  const total = slideEls.length;
  if (!total) return;

  // Create bullets
  paginationEl.innerHTML = "";
  const bullets = [];
  for (let i = 0; i < total; i++) {
    const bullet = document.createElement("button");
    bullet.type = "button";
    bullet.className = "vibe-bundles-bullet";
    bullet.setAttribute("data-index", String(i));
    paginationEl.appendChild(bullet);
    bullets.push(bullet);
  }

  let currentIndex = 0;

  function updateUi() {
    const offset = -currentIndex * 100;
    trackEl.style.transform = `translateX(${offset}%)`;

    counterEl.textContent = `${currentIndex + 1} / ${total}`;

    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex === total - 1;

    bullets.forEach((b, idx) => {
      if (idx === currentIndex) {
        b.classList.add("vibe-bundles-bullet--active");
      } else {
        b.classList.remove("vibe-bundles-bullet--active");
      }
    });
  }

  function goToSlide(index) {
    const clamped = Math.max(0, Math.min(index, total - 1));
    if (clamped === currentIndex) return;
    currentIndex = clamped;
    updateUi();
  }

  prevBtn.addEventListener("click", () => {
    goToSlide(currentIndex - 1);
  });

  nextBtn.addEventListener("click", () => {
    goToSlide(currentIndex + 1);
  });

  bullets.forEach((bullet) => {
    bullet.addEventListener("click", () => {
      const idx = Number(bullet.getAttribute("data-index") || "0");
      goToSlide(idx);
    });
  });

  // Initial state
  updateUi();
}

/**
 * Build persona data from product.
 * You’ll replace this mapping later with real metafields etc.
 */
function createPersonaFromProduct(product) {
  const bodyHtml = product.body_html || "";
  const tags = Array.isArray(product.tags) ? product.tags : [];

  const descriptionText = stripHtml(bodyHtml).trim();
  const description =
    descriptionText.length > 260
      ? descriptionText.slice(0, 257) + "..."
      : descriptionText;

  return {
    title: tags[0],
    label: product.vendor,
    tagline: getFirstDescriptionSnippet(product.body_html),
    description,
    chips: tags.slice(0, 5),
    badgeLabel: tags[0],
    badgeColorClass: "vibe-badge--peach",
  };
}

function createVibeSlideHtml(product, persona) {
  const handle = product.handle;
  const title = product.title || "";
  const topTitle = persona.title || "";
  const safeTitle = escapeHtml(title);

  const images = Array.isArray(product.images) ? product.images : [];
  const img0 = images[0]?.src || "";
  const img2 = images[2]?.src || "";

  /* -----------------------------
     TAG LOGIC (tag_)
  ----------------------------- */
  let badgeText = "";
  if (Array.isArray(product.tags)) {
    const tag = product.tags.find((t) =>
      String(t).toLowerCase().startsWith("tag_")
    );
    if (tag) badgeText = escapeHtml(String(tag).replace(/^tag_/i, ""));
  }

  /* -----------------------------
     VIDEO LOGIC (FIRST VIDEO ONLY)
     - prefer mp4
     - normalize //cdn... => https://cdn...
  ----------------------------- */
  const videos = window.VIBE_PRODUCT_MEDIA?.[handle]?.videos || [];
  const video = videos[0];

  let primaryMediaHtml = "";
  let hasVideo = false;

  if (video && video.media_type === "video" && Array.isArray(video.sources)) {
    const mp4 = video.sources.find((s) => s?.mime_type === "video/mp4");
    const source = mp4 || video.sources[0];

    if (source?.url) {
      const src = String(source.url).startsWith("//")
        ? `https:${source.url}`
        : source.url;

      hasVideo = true;

      primaryMediaHtml = `
        <div class="vibe-media">
          <video
            class="vibe-card-video"
            autoplay
            muted
            loop
            playsinline
            preload="metadata"
            poster="${img0}"
          >
            <source src="${src}" type="${source.mime_type || "video/mp4"}" />
          </video>
        </div>
      `;
    }
  }

  // External video (optional support, safe)
  if (
    !hasVideo &&
    video &&
    video.media_type === "external_video" &&
    video.embed_url
  ) {
    hasVideo = true;
    const src = String(video.embed_url);
    // ensure autoplay parameters
    const joiner = src.includes("?") ? "&" : "?";
    const iframeSrc = `${src}${joiner}autoplay=1&mute=1&loop=1&controls=0&playsinline=1`;

    primaryMediaHtml = `
      <div class="vibe-media">
        <iframe
          class="vibe-card-video"
          src="${iframeSrc}"
          frameborder="0"
          allow="autoplay; encrypted-media; fullscreen"
          allowfullscreen
        ></iframe>
      </div>
    `;
  }

  // Fallback to image ONLY if no video (IMPORTANT: never render both)
  if (!primaryMediaHtml) {
    primaryMediaHtml = `
      <div class="vibe-media">
        <img class="vibe-card-image-el" src="${img0}" alt="${safeTitle}" loading="lazy" />
      </div>
    `;
  }

  /* -----------------------------
     PERSONA CONTENT
  ----------------------------- */
  const label = escapeHtml(persona.title || "");
  const tagline = persona.tagline ? escapeHtml(persona.tagline) : "";
  const desc = persona.description ? escapeHtml(persona.description) : "";

  const chipsHtml = (persona.chips || [])
    .map((chip) => `<span class="vibe-chip">${escapeHtml(chip)}</span>`)
    .join("");

  const badgeClass = persona.badgeColorClass || "vibe-badge--peach";

  const sparklesIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063L2.365 12.48a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.58a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"
        fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" />
      <path d="M20 3v4M22 5h-4M4 17v2M5 18H3"
        fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  `;

  return `
    <div class="vibe-bundles-slide">
      <div class="vibe-card">
        <div class="vibe-card-images">

          <a href="/products/${handle}?view=single-product" class="vibe-card-image vibe-card-image--primary">
            ${primaryMediaHtml}
            ${
              badgeText
                ? `<span class="vibe-badge ${badgeClass}">${badgeText}</span>`
                : ""
            }
            <div class="vibe-card-image-caption"><h3 class="fraunces-font">${safeTitle}</h3></div>
          </a>

          <a href="/products/${handle}?view=single-product" class="vibe-card-image vibe-card-image--secondary">
            ${
              img2
                ? `<img src="${img2}" alt="${safeTitle} second view" loading="lazy" />`
                : ""
            }
            ${
              img2
                ? `<div class="vibe-card-image-caption fraunces-font"><h3>${safeTitle}</h3></div>`
                : ""
            }
          </a>

        </div>

       
<div class="vibe-card-body">

  <!-- Label row -->
  <div class="vibe-card-label-row">
    <span class="vibe-card-label-icon">
      ${
        sparklesIcon ||
        `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>
          <path d="M20 3v4"/>
          <path d="M22 5h-4"/>
          <path d="M4 17v2"/>
          <path d="M5 18H3"/>
        </svg>
      `
      }
    </span>

    <span class="vibe-card-label-text">
      ${label}
    </span>
  </div>

  <!-- Title -->
  <h3 class="vibe-card-title fraunces-font">
    ${safeTitle}
  </h3>

  <!-- Tagline -->
  
  <p class="vibe-card-tagline">"${tagline}"</p>
   

  <!-- Description -->
   <p class="vibe-card-description">${desc}</p>
     
  

  <!-- Price row (HARDCODED) -->
  <div class="vibe-price-row">
    <span class="vibe-price-old">$120</span>
    <span class="vibe-price-new">$108</span>

    <span class="vibe-subscribe-badge">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/>
        <circle cx="7.5" cy="7.5" r=".5"/>
      </svg>
      Subscribe &amp; Save
    </span>
  </div>

  <!-- Meta (HARDCODED) -->
  <p class="vibe-card-meta">
    Variety of colors included • Apparel: XS–3X • Jeans: 0–24
  </p>

  <!-- Tags -->
    <div class="vibe-chip-row">${chipsHtml}</div>

  <!-- CTA -->
  <a href="/products/${handle}?view=single-product" class="vibe-card-cta">
    BUY ${safeTitle || "NOW"}
  </a>

  <!-- Footer note -->
  <p class="vibe-card-note">
    After purchase, you'll receive a personalization email to share your sizes,
    color preferences &amp; style notes.
  </p>

</div>

      </div>
    </div>
  `;
}

/**
 * Helpers
 */
function stripHtml(html) {
  if (!html) return "";
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

function escapeHtml(str) {
  return String(str || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
